import React from 'react';
import './App.css'
import Product from './components/Product';
import Data from './components/data.json'
import Cart from './components/Cart';
import OrderConfirmed from './components/OrderConfirmed';

function App() {
  const [data, setData] = React.useState(Data)
  const [cart, setCart] = React.useState([])
  const [orderConfirmed, setOrderConfirmed] = React.useState(false);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);


  function startNewOrder(){
    setOrderConfirmed(false)
    setCart([])
    setData(Data)
  }

  function handleResize(){
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    // Agregar el listener para el cambio de tamaño de la ventana
    window.addEventListener('resize', handleResize);

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 

  return (
    <>
    <div className={ orderConfirmed ? "container order-confirmed" :"container"}>

      <div className="container-desserts">
        <h1>Desserts</h1>
        <div className="container-products">
          {
            data.map((product,index) => {
              return <Product 
                        key={index}
                        image={product.image}
                        name={product.name}
                        category={product.category}
                        price={product.price.toFixed(2)}
                        setCart={setCart}
                        cart={cart}
                        windowWidth={windowWidth}
                      />
            })
          }
        </div>
      </div>

      <Cart 
        cart={cart} 
        setCart={setCart}
        setOrderConfirmed={setOrderConfirmed}
      />

    </div>
      {
        orderConfirmed &&
        <OrderConfirmed 
          cart={cart} 
          startNewOrder={startNewOrder} 
        />
      }
    </>
  );
  
}

export default App;
